import { render, staticRenderFns } from "./RelationSearch.vue?vue&type=template&id=474e5ce8&scoped=true&"
import script from "./RelationSearch.vue?vue&type=script&lang=js&"
export * from "./RelationSearch.vue?vue&type=script&lang=js&"
import style0 from "./RelationSearch.vue?vue&type=style&index=0&id=474e5ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474e5ce8",
  null
  
)

export default component.exports